module.exports = __webpack_public_path__ + "static/media/whoneedsprint3.ce13db6e.jpg";